declare namespace $ {

	type $mol_paragraph__title_demo_note_card_1 = $mol_type_enforce<
		ReturnType< $demo_note_card['note_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_demo_note_card_2 = $mol_type_enforce<
		ReturnType< $demo_note_card['note_body'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $demo_note_card_zone__label_demo_note_card_3 = $mol_type_enforce<
		ReturnType< $demo_note_card['author_name'] >
		,
		ReturnType< $demo_note_card_zone['label'] >
	>
	type $demo_note_card_zone__label_demo_note_card_4 = $mol_type_enforce<
		ReturnType< $demo_note_card['like_title'] >
		,
		ReturnType< $demo_note_card_zone['label'] >
	>
	type $mol_button_minor__title_demo_note_card_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_demo_note_card_6 = $mol_type_enforce<
		ReturnType< $demo_note_card['like'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_demo_note_card_7 = $mol_type_enforce<
		ReturnType< $demo_note_card['renders_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_row__sub_demo_note_card_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	export class $demo_note_card extends $mol_view {
		flash_phase( ): string
		note_title( ): string
		Title( ): $mol_paragraph
		note_body( ): string
		Body( ): $mol_paragraph
		author_name( ): string
		Author( ): $demo_note_card_zone
		like_title( ): string
		Likes( ): $demo_note_card_zone
		like( next?: any ): any
		Like( ): $mol_button_minor
		renders_title( ): string
		Renders( ): $mol_paragraph
		Foot( ): $mol_row
		note_ref( ): $demo_note_card_note_ref | null
		attr( ): ({ 
			'demo_flash': ReturnType< $demo_note_card['flash_phase'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
	type $mol_paragraph__title_demo_note_card_zone_1 = $mol_type_enforce<
		ReturnType< $demo_note_card_zone['label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_demo_note_card_zone_2 = $mol_type_enforce<
		ReturnType< $demo_note_card_zone['renders_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $demo_note_card_zone extends $mol_view {
		flash_phase( ): string
		label( ): string
		Label( ): $mol_paragraph
		renders_title( ): string
		Renders( ): $mol_paragraph
		attr( ): ({ 
			'demo_flash': ReturnType< $demo_note_card_zone['flash_phase'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map